import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const DiscountEdit = () => {
  const users = {
   disc_name: "",
    disc_amount: "",
    disc_start_date: "",
    disc_end_date: "",
    status: "",
  };

  const [DiscountEditUser, setDiscountEditUser] = useState(users);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPedagogyData = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_discount_by_id",
          {
            disc_id: id,
          }
        );
        setDiscountEditUser(response.data.data);
      } catch (error) {
        console.error("Error fetching Pedagogy data!", error);
      }
    };

    fetchPedagogyData();
  }, [id]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setDiscountEditUser({ ...DiscountEditUser, [name]: value });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_discount",
        {
          disc_id: id,
          ...DiscountEditUser,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

    
        toast.success(response.data.message || "Data Updated Successfully!");
        navigate("/Discount-list");

    } catch (error) {
      console.error(
        "There was an error!",
        error.response?.data || error.message
      );
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Discount Edit</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Discount</a>
                </li>
                <li className="breadcrumb-item active">Discount Edit</li>
              </ol>
            </div>
          </div>
        </div>
        {/* ========== Page Title End ========== */}
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Edit Discount</h4>
              </div>
              <form onSubmit={submitForm}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label
                          htmlFor="disc_name"
                          className="form-label text-dark"
                        >
                          Discount Name
                        </label>
                        <input
                          type="text"
                          id="disc_name"
                          name="disc_name"
                          className="form-control"
                          placeholder="Enter Name"
                          value={DiscountEditUser.disc_name}
                          onChange={changeHandler}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label
                          htmlFor="disc_amount"
                          className="form-label text-dark"
                        >
                          Discount Percentage (%)
                        </label>
                        <input
                          type="number"
                          id="disc_amount"
                          name="disc_amount"
                          className="form-control"
                          placeholder="Enter Value"
                          value={DiscountEditUser.disc_amount}
                          onChange={changeHandler}
                        />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label
                          htmlFor="disc_start_date"
                          className="form-label text-dark"
                        >
                          Start Date
                        </label>
                        <input
                          type="date"
                          id="disc_start_date"
                          name="disc_start_date"
                          className="form-control"
                          placeholder="Enter Value"
                          value={DiscountEditUser.disc_start_date}
                          onChange={changeHandler}
                        />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label
                          htmlFor="disc_end_date"
                          className="form-label text-dark"
                        >
                          End Date
                        </label>
                        <input
                          type="date"
                          id="disc_end_date"
                          name="disc_end_date"
                          className="form-control"
                          placeholder="Enter Value"
                          value={DiscountEditUser.disc_end_date}
                          onChange={changeHandler}
                        />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="status" className="form-label">
                          Status
                        </label>
                        <select
                          className="form-control"
                          id="status"
                          name="status"
                          value={DiscountEditUser.status}
                          onChange={changeHandler}
                          required
                        >
                          <option value="">Select Status</option>
                          <option value="Active">Active</option>
                          <option value="InActive">InActive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer border-top">
                  <button type="submit" className="btn btn-primary">
                    Edit Change
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* End Container Fluid */}
      {/* ========== Footer Start ========== */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <a href="" className="fw-bold footer-text" target="_blank">
                Techzaa
              </a>
            </div>
          </div>
        </div>
      </footer>
      {/* ========== Footer End ========== */}
    </div>
  );
};

export default DiscountEdit;
